const NothingToDeclareData = {
  title: "Nothing to declare",
  description: {
    i18nKey: "nothing_to_declare_form_message",
    label:
      "This form is to be completed at the end of the month, only if you have no other events to report for that same month.",
  },
  fields: [
    {
      name: "month",
      label: "I declare that I have no events to report for the month of:",
    },
    {
      name: "comment",
      label: "nothing_comment",
    },
  ],
};

export default NothingToDeclareData;
